import { architectsSections } from "constants/architectsTranslation";
import useLastPath from "customHooks/useLastPath";
import useTranslation from "next-translate/useTranslation";
import styled from "styled-components";
const ArchitectsSidebarContent = () => {
  const { t } = useTranslation("common");
  const content = architectsSections.map((section) => {
    return section.label;
  });
  const lastPath = useLastPath();

  return (
    <div className="cs-sidebar col-lg-3 pt-lg-4 d-none d-lg-block px-4  ">
      <div className="cs-widget my-3">
        <h3 className="cs-widget-title">{t("header_about")}</h3>
        <StyledAccordion className="cs-widget my-3">
          <div className="cs-widget mb-5">
            <div className="widget widget-categories mb-5">
              <ul>
                {content?.map((cont, idx) => {
                  const isLastPath = lastPath === cont;

                  return (
                    <li className="d-flex" key={idx}>
                      <i className="fe-book text-muted mt-2 mr-2"></i>

                      <a
                        className={`cs-widget-link ${
                          isLastPath ? "active" : ""
                        }`}
                        href={`#${cont}`}
                        style={{ width: "fit-content" }}
                      >
                        {t(cont)}
                      </a>
                    </li>
                  );
                })}
              </ul>
            </div>
          </div>
        </StyledAccordion>
      </div>
    </div>
  );
};

export default ArchitectsSidebarContent;
const StyledAccordion = styled.div`
  .collapse {
    max-height: 0;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0, 1, 0, 1);
    display: block;
    pointer-events: none;
    padding: 0 !important;
    margin: ${({ theme }) =>
      theme.rtl ? ".25rem  1.375rem 0 0" : ".25rem 0 0 1.375rem"};
  }
  .collapse.show {
    height: auto;
    max-height: 9999px;
    pointer-events: all;
    transition: all 0.5s cubic-bezier(1, 0, 1, 0);
    margin: ${({ theme }) =>
      theme.rtl ? ".25rem  1.375rem 0 0" : ".25rem 0 0 1.375rem"};
  }
`;
